// The one office phone number and email every borrower-facing page shows.
//
// CONSUMER: both. Form brands, application thank-you copy, and the guard
// test that fails the build when a borrower-facing form shows any other
// number or address.
//
// WHY ONE PLACE (Grant, 2026-10-02): the KlinkLoans and First Tier
// applications showed (480) 447-4009, a number nobody supplied, while the
// real office line, (602) 384-2604, was already on every other page. A
// number typed into prose can drift; a constant read everywhere cannot.
// Do not type the office number or email into form copy: import these.

export const OFFICE_PHONE_E164 = "16023842604";
export const OFFICE_PHONE_DISPLAY = "(602) 384-2604";
export const OFFICE_EMAIL = "home@stewardship.pro";
/** The privacy policy every client page's footer links to. It lives on the
 *  marketing site, which has one address in every environment (staging has
 *  no copy of it), so it is a constant here rather than an environment
 *  address; client standard rule 8 is about OUR app's addresses. */
export const PRIVACY_POLICY_URL = "https://stewardship.pro/privacy-policy/";
